import { DeviceGrid } from "@gtpl/pages/canteen-management/canteen-management-components/device-grid"
import { EmployeeTokens, EmployeeTokensGrid, Freebies } from "@gtpl/pages/canteen-management/canteen-management-components/freebies-form"
import React from "react"
import { FreebiesGrid, employeeReport } from '@gtpl/pages/canteen-management/canteen-management-components/freebies-grid';
import { Route } from "react-router-dom"
import { DeviceForm } from "@gtpl/pages/canteen-management/canteen-management-components/device-form";
import { ScanTokenForm } from '@gtpl/pages/canteen-management/canteen-management-components/scan-token-form'
import { EmployeeRolesEnum } from "@gtpl/shared-models/common-models";

const CmsRouting = () => {
    return (
        <>
        {((JSON.parse(localStorage.getItem('role'))===EmployeeRolesEnum.ADMIN))&&
        <>
         <Route exact path="/device-view" component={DeviceGrid} />
            <Route exact path="/freebies-view" component={FreebiesGrid} />
            <Route exact path="/employeetokens-grid" component={EmployeeTokensGrid} />
            <Route exact path="/freebies-form" render={props => <Freebies
                Data={undefined}
                updateData={(undefined) => { }}
                isUpdate={false}
                closeForm={() => { }}
            />} />
            <Route exact path="/employeetokens-form" render={props => <EmployeeTokens
                updateData={(undefined) => { }}
                Data={undefined}
                isUpdate={false}
                closeForm={() => { }}
            />} />
            <Route exact path="/device-form" render={props => <DeviceForm
                Data={undefined}
                updateData={(undefined) => { }}
                isUpdate={false}
                closeForm={() => { }}
            />} />
            <Route exact path="/scan-token" component={ScanTokenForm} />

        </>}
           
        </>
    )
}
export default CmsRouting;